import(/* webpackMode: "eager" */ "/codebuild/output/src2304138533/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
